/**

Coded by www.techhighway.ca

*/

import { useState } from "react";

// Material Dashboard 2 React components
import MDSnackbar from "components/MDSnackbar";

export default function customAlert() {
  // Alert Notification starts
  const [alertSB, setAlertSB] = useState(false);
  const [colorSB, setColorSB] = useState("");
  const [iconSB, setIconSB] = useState("");
  const [contentSB, setContentSB] = useState("");
  const [titleSB, setTitleSB] = useState("");

  const openAlertSB = (props) => {
    setAlertSB(true);
    setColorSB(props?.color);
    setIconSB(props?.icon);
    setContentSB(props?.msg);
    setTitleSB(props?.title);
  };

  const closeAlertSB = () => {
    setAlertSB(false);
  };

  const validColors = ["primary", "secondary", "info", "success", "warning", "error", "dark", "light"];
  const color = validColors.includes(colorSB) ? colorSB : "info";

  const renderAlertSB = (
    <MDSnackbar
      color={color}
      icon={iconSB}
      title={titleSB}
      content={contentSB}
      open={alertSB}
      onClose={closeAlertSB}
      close={closeAlertSB}
      bgWhite
    />
  );
  // Alert Notification ends
  return {
    openAlertSB,
    closeAlertSB,
    renderAlertSB,
  };
}
